import { TranslationActionTypes } from 'src/store/actions/translationActions';
export const initialState = {};
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case TranslationActionTypes.TRANSLATION_SET_LANG:
            return {
                ...state,
                locale: payload
            };
        default:
            return state;
    }
};
